import { EventType } from "@/analytics/analytics-events";
import { IpxOrderTask } from "@/utils/background-tasks";
import { TranslateVar } from "@faro-lotv/flat-ui";
import { Analytics } from "@faro-lotv/foreign-observers";
import type { JSX } from "react";
import { GenericCardLayout } from "../layouts/generic-card-layout";

type IpxOrderTaskCardProps = {
  /** The order placed at IPX */
  task: IpxOrderTask;
};

/** @returns the card of an order placed at IPX, linking to the IPX status page */
export function IpxOrderTaskCard({ task }: IpxOrderTaskCardProps): JSX.Element {
  const { orderId, deliverables, statusUrl } = task.metadata;

  return (
    <GenericCardLayout
      name={deliverables}
      subText={
        <>
          Ordered from IPX ·{" "}
          <TranslateVar name="orderId">{orderId}</TranslateVar>
        </>
      }
      startTime={task.createdAt}
      action={{
        name: "View at IPX",
        callback: () => {
          Analytics.track(EventType.openIpxOrderStatus);
          window.open(statusUrl, "_blank", "noopener,noreferrer");
        },
      }}
    />
  );
}
